export default __webpack_public_path__ + "static/top-46c402a52bdf0c37e3cd6722bb8ee894.jpg";